// extracted by mini-css-extract-plugin
module.exports =  {"notification":"ZWu5s3","icon":"ITXgg4","buttonContent":"YJhbpW"};